import { KeyboardNavigation } from 'Shared/keyboard_navigation';
import { initializeReactQuery } from 'Shared/react-query-initialize';
import { ViewLangIntlProvider } from 'Shared/use_intl';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { getSearchClient } from 'Guide/searchClient';
import { getGrowthbook } from 'Shared/features';
import { renderTrackedAsync } from 'Shared/react-mount-tracker';

new KeyboardNavigation({
   keys: {
      'C-k': deviceNavigator,
      'M-k': deviceNavigator,
   },
});

const opening = { isInFlight: false };

// Ctrl-K and the home page's "Find your device" button open the picker. Its
// code (the modal dialog among it) is fetched on the first open, so the pages
// that load this file don't download it up front. The readiness gate covers
// the fetch, and a second press while it runs opens nothing more.
export default async function deviceNavigator() {
   if (opening.isInFlight || document.querySelector('[data-testid="devicePickerComponent"]')) {
      return;
   }
   opening.isInFlight = true;
   const node = document.createElement('div');
   document.body.append(node);
   try {
      await renderTrackedAsync(node, async () => {
         const [{ DevicePickerModal }, growthbook] = await Promise.all([
            import('@ifixit/device-picker'),
            getGrowthbook(),
         ]);
         return initializeReactQuery(
            <ViewLangIntlProvider>
               <GrowthBookProvider growthbook={growthbook}>
                  <DevicePickerModal
                     defaultOpen={true}
                     onSelect={device => (window.location.href = device.url)}
                     algoliaConfig={{
                        searchClient: getSearchClient(),
                        indexPrefix: App.algoliaConfig['indexPrefix'],
                     }}
                     oniFixit={App.which === 'ifixit'}
                     langid={App.lang}
                     storeLocale={App.userPreferredStoreLocale}
                     treeNavigationProps={'showAreaButtons'}
                     analyticsKey={'Navigator'}
                  />
               </GrowthBookProvider>
            </ViewLangIntlProvider>
         );
      });
   } catch (error) {
      node.remove();
      throw error;
   } finally {
      opening.isInFlight = false;
   }
}
